/** Textes « sinistres » — le français fait foi. */
export const sinistres = {
  enregistre: 'Sinistre enregistré.',
  erreur: 'Erreur',
  titre: 'Accidents',
  sousTitre: "Calculateur de l'article 06 — la règle appliquée est écrite en toutes lettres",
  circonstancesMontants: 'Circonstances et montants',
  vehicule: 'Véhicule',
  choisir: 'Choisir…',
  circonstances: 'Circonstances',
  cases: {
    ivresse: "Conduite en état d'ivresse", faitVolontaire: 'Fait volontaire',
    negligence: 'Négligence', locataireFautif: 'Locataire fautif à 100 %',
  },
  aucuneCase: "Aucune case cochée = locataire non fautif : la règle des 60 % s'applique.",
  carrosserie: (d: string) => `Devis carrosserie (${d})`,
  mecanique: (d: string) => `Devis mécanique (${d})`,
  mainOeuvreDevise: (d: string) => `Main d'oeuvre (${d})`,
  jours: "Jours d'immobilisation",
  tarifJour: (d: string) => `Tarif journalier (${d})`,
  assurance: (d: string) => `Prise en charge assurance (${d})`,
  recit: "Ce qui s'est passé",
  recitAide: "Où, comment, qui conduisait, ce que dit le constat. C'est ce récit qui sera relu en cas de litige.",
  recitExemple: 'Ex. : sortie de route sur la RN5 à hauteur de Réghaïa, chaussée mouillée, constat amiable signé, pas de tiers.',
  resultat: 'Résultat',
  chargeLocataire: 'A la charge du locataire',
  reparation: 'Réparation',
  mainOeuvre: "Main d'oeuvre",
  immobilisation: 'Immobilisation',
  enregistrer: 'Enregistrer le sinistre',
  reserve: "Vous pouvez simuler autant que vous voulez. L'enregistrement d'un sinistre est une opération financière : il est réservé au gérant · finances.",
  enregistres: 'Sinistres enregistrés',
  aucun: 'Aucun sinistre',
  col: { date: 'Date', vehicule: 'Véhicule', regle: 'Règle appliquée', part: 'Part locataire', caution: 'Caution déduite', reste: 'Reste dû' },
  constat: 'Constat',
  note: "Facturer 60 % a un locataire non fautif est une clause commercialement agressive : c'est la vôtre, elle est appliquée telle quelle. C'est aussi celle qui génère le plus de litiges — l'état des lieux photographique du départ reste votre meilleure protection.",
};
